import { render, staticRenderFns } from "./CulturePromotionPlatformType.vue?vue&type=template&id=7403d029&scoped=true&"
import script from "./CulturePromotionPlatformType.vue?vue&type=script&lang=js&"
export * from "./CulturePromotionPlatformType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403d029",
  null
  
)

export default component.exports